import SurveyBaseController from './survey_base_controller';

export default class CreatorBaseController extends SurveyBaseController {

  connect() {
    super.connect();
  }

  initializeCreator(mode) {

    const creatorOptions = {
      isAutoSave: false,
      showLogicTab: true,
      showTranslationTab: true,
      showThemeTab: true,
      maxPanelNestingLevel: 1,
      forbiddenNestedElements: {
        panel: ["panel", "paneldynamic"]
      }
    };


    if (mode === 'preview') {
      creatorOptions.readOnly = true;
      creatorOptions.showDesignerTab = false;
      creatorOptions.showJSONEditorTab = true;
      creatorOptions.previewDevice = this.getCookie("surveyPreviewDevice") || "iPhoneSE";
      creatorOptions.previewOrientation = this.getCookie("surveyPreviewOrientation") || "portrait";
    }

    const translations = SurveyCreatorCore.getLocaleStrings("en");
    translations.ed.jsonEditor = "Edit As Text";

    const creator = new SurveyCreator.SurveyCreator(creatorOptions);
    this.registerQuestionFromTenant(creator);
    this.registerQuestionSubitemLimitedLongText(creator);
    // this.registerQuestionGroupOverallFeedback(creator);
    // this.registerQuestionGroupTakeAPhoto(creator);
    // this.registerQuestionTimeTaken(creator);
    this.registerQuestionsFromTasks(creator);
    creator.showToolbox = true;
    creator.showPreviewTab = false;
    creator.toolbox.forceCompact = false;

    // Mission name is the source of truth for survey title, so lock it here
    creator.onGetPropertyReadOnly.add((sender, options) => {
      if (options.obj.getType() === "survey" && options.property.name === "title") {
        options.readOnly = true;
      }
    });

    // reorder the toolbox items
    creator.toolbox.orderedQuestions = [
      "tenant-questions",
      "camera-upload-question",
      "camera-mult-upload-question",
      "country",
      "boolean",
      "dropdown",
      "checkbox",
      "radiogroup",
      "rating",
      "comment",
      "tagbox",
      "file",
      "imagepicker",
      "ranking",
      "text",
      "multipletext",
      "panel",
      "paneldynamic",
      "matrix",
      "matrixdropdown",
      "matrixdynamic",
      "html",
      "expression",
      "image",
      "signaturepad"
    ]

    // log the current toolbox order
    this.logToolboxItems(creator);

    return creator;
  }

  getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  setCookie(name, value) {
    document.cookie = `${name}=${encodeURIComponent(value)};path=/;max-age=${60 * 60 * 24 * 365};SameSite=Lax`;
  }

  logToolboxItems(creator) {
    // console.log(creator.toolbox.items.map(item => item.name));
  }

  registerQuestionSubitemLimitedLongText(creator) {
    const longTextItem = creator.toolbox.getItemByName("comment");
    longTextItem.addSubitem({
      name: "limitedLongText",
      title: "Limited to 280 characters",
      json: {
        type: "comment",
        maxLength: 280
      }
    });

  }

  registerQuestionTimeTaken(creator) {
    const tenantQuestionItem = creator.toolbox.getItemByName("tenant-questions");
    const questiongroupItem = {
      id: "1",
      name: "time-taken",
      title: "Time Taken",
      iconName: "icon-panel",
      isCopied: true,
      json: {
        "type": "text",
        "name": "time-taken",
        "title": "How long did it take you to complete this mission?",
        "isRequired": true,
        "inputType": "number",
        "min": 1,
        "max": 480,
        "step": 1
      }
    };
    tenantQuestionItem.addSubitem(questiongroupItem);
  }

  registerQuestionFromTenant(creator) {
    const questiongroupItem = {
      id: "2",
      name: "tenant-questions",
      title: "Retail Tasker",
      iconName: "icon-toolbox-tagbox-16x16",
      isCopied: true
    };
    creator.toolbox.addItem(questiongroupItem);
  }


  registerQuestionGroupTakeAPhoto(creator) {
    const tenantQuestionItem = creator.toolbox.getItemByName("tenant-questions");
    const questiongroupItem = {
      id: "2",
      name: "tenant-questions",
      title: "Take a Photo",
      iconName: "icon-toolbox-tagbox-16x16",
      isCopied: true,
      json: {
        "type": "panel",
        "name": "take-a-photo-panel",
        "elements": [
          {
            "type": "boolean",
            "name": "take-a-photo",
            "title": "Did you get a display up?"
          },
          {
            "type": "camera-upload-question",
            "name": "question2",
            "visibleIf": "{question1} = true",
            "title": "Merchandise and take a photo"
          }
        ]
      }
    };
    tenantQuestionItem.addSubitem(questiongroupItem);
  }

  registerQuestionGroupOverallFeedback(creator) {
    const tenantQuestionItem = creator.toolbox.getItemByName("tenant-questions");
    const questiongroupItem = {
      id: "2",
      name: "tenant-questions",
      title: "Overall Feedback",
      iconName: "icon-toolbox-tagbox-16x16",
      isCopied: true,
      json: {
        "type": "panel",
        "name": "has-feedback-panel",
        "description": "General Feedback",
        "isRequired": true,
        "elements": [
          {
            "type": "boolean",
            "name": "has-feedback",
            "title": "Do you have any feedback?",
            "isRequired": true
          },
          {
            "type": "comment",
            "name": "feedback",
            "visibleIf": "{has-feedback} = true",
            "title": "Provide feedback",
            "isRequired": true,
            "autoGrow": true,
            "allowResize": false
          }
        ]
      }
    };
    tenantQuestionItem.addSubitem(questiongroupItem);
  }

  // Fetch questions from the API asynchronously
  async fetchQuestionsFromAPI() {
    try {
      const response = await fetch(`/api/v1/tasks.json`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      });

      if (!response.ok) {
        throw new Error("Failed to fetch tasks");
      }

      return await response.json();  // Await the JSON response and return it
    } catch (error) {
      console.error("Error fetching questions:", error);
      throw error;  // Rethrow the error for the calling function to handle
    }
  }


  async registerQuestionsFromTasks(creator) {
    try {
      // Wait for the data to be fetched asynchronously
      const data = await this.fetchQuestionsFromAPI();  // This will pause until fetch is complete
      // console.log("Fetched questions:", data);

      const tenantQuestionItem = creator.toolbox.getItemByName("tenant-questions");

      if (!tenantQuestionItem) {
        throw new Error("Toolbox item 'tenant-questions' not found");
      }

      // Process each question in the fetched data
      for (const question of data) {
        const survey_json = JSON.stringify(question.survey_json);
        if (survey_json === "{}" || survey_json === "[]") {
          continue;  // Skip if the survey_json is empty or invalid
        }

        const survey_elements = question.survey_json.pages[0].elements;
        if (survey_elements && survey_elements.length > 0) {
          const questiongroupItem = {
            id: String(question.id),
            name: "tenant-questions",
            title: question.name || survey_elements[0].name,
            iconName: "icon-toolbox-tagbox-16x16",
            isCopied: true,
            json: survey_elements[0]  // Pass the JSON object directly
          };

          // Add the item to the SurveyJS toolbox
          tenantQuestionItem.addSubitem(questiongroupItem);
        }
      }

    } catch (error) {
      console.error("Error processing questions:", error);
    }
  }
}